import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ProductSlidesPage } from './product-slides.page';

const routes: Routes = [
  {
    path: '',
    component: ProductSlidesPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProductSlidesPageRoutingModule {}
